import { FC } from "react";
import { MenuButton as ChakraMenuButton } from "@chakra-ui/react";

import { theme } from "@ovou-inc/ovou-ui";
import { HiChevronDown, HiChevronUp } from "react-icons/hi";

import { Flex, Image, Text } from "components";

interface IMultiTeamMenuButton {
  isOpen: boolean;
  logo?: string;
  title?: string;
}

const MultiTeamMenuButton: FC<IMultiTeamMenuButton> = ({
  isOpen,
  logo,
  title,
}) => {
  return (
    <ChakraMenuButton
      boxSizing="border-box"
      minWidth="max-content"
      borderRadius="8px"
      border={`1px solid ${theme.palette.ui.greys.grey3}`}
      height="48px"
      width="100%"
      paddingX="11px"
      paddingY="8px"
      backgroundColor={theme.palette.brand.primary.white}
      borderWidth="1px"
      borderColor={theme.palette.ui.greys.grey3}
      fontWeight="semibold"
      fontSize="0.875rem"
      textColor={theme.palette.brand.primary.black}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      _hover={{
        backgroundColor: theme.palette.ui.greys.grey5,
      }}
      _focus={{
        backgroundColor: theme.palette.ui.greys.grey5,
      }}
    >
      <Flex alignItems="center" maxWidth="210px">
        <Image
          width="32px"
          height="32px"
          backgroundSize="cover"
          borderRadius="4px"
          src={logo}
          alt={logo ? "Brand Logo" : "Default Logo"}
          marginRight="8px"
        />
        <Text fontSize="14px" fontWeight={600} isTruncated>
          {title}
        </Text>
      </Flex>
      {isOpen ? (
        <HiChevronUp color={theme.palette.ui.greys.grey2} size={16} />
      ) : (
        <HiChevronDown color={theme.palette.ui.greys.grey2} size={16} />
      )}
    </ChakraMenuButton>
  );
};

export default MultiTeamMenuButton;
